import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Form, Button, Modal, Icon, Select, message, Row } from 'antd';
import { fetchSimpleResource, saveResource } from 'ACTIONS/resources.actions';
import { decode } from 'html-entities';
import './ResendNewsletterForm.less';

const { Option } = Select;

class ResendNewsletterForm extends Component {
  state = {
    sendTo: undefined,
  };

  componentDidMount() {
    this.props.fetchSimpleResource('accounts', { per_page: 1000 });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isSaving && !this.props.isSaving && this.props.isCompleted) {
      message.success('Good job! Please check the table below to make sure all the newsletters were scheduled!', 5);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    const submitForm = () => {
      form.validateFields((err, values) => {
        if (!err) {
          const data = (values.sendTo) ? { account_id: values.sendTo } : {};
          this.props.saveResource('resendNewsletter', data, {
            path: 'tasks/resend-newsletter',
          });
        }
      });
    };

    Modal.confirm({
      title: 'Are you sure you want to resend the newsletter?',
      content: 'This is an irreversible action!',
      onOk: submitForm,
      onCancel() {},
      cancelText: 'Oh crap!',
      okText: 'Yes, I\'m sure!',
    });
  };

  handleChange = (value) => {
    this.props.form.setFieldsValue({
      sendTo: value,
    });
    this.setState({
      sendTo: value,
    });
  };

  render() {
    const { isSaving, accounts } = this.props;
    const {
      getFieldDecorator,
    } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} disabled={isSaving} layout="inline">
        <Row>
          <Form.Item>
            {getFieldDecorator('sendTo', {
              initialValue: this.state.sendTo,
            })(
              <Select
                showSearch
                style={{ width: 220 }}
                placeholder="Select a site"
                optionFilterProp="children"
                onChange={this.handleChange}
                filterOption={
                  (input, option) => option.props
                    .children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {accounts.map(account => (
                  <Option key={account.id} value={account.id}>
                    {decode(account.name)}
                  </Option>
                ))
                }
              </Select>,
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={isSaving}>
              <Icon type={isSaving ? 'loading' : 'rocket'} />
              Send
            </Button>
          </Form.Item>
        </Row>
      </Form>
    );
  }
}

ResendNewsletterForm.defaultProps = {
  isSaving: false,
  isCompleted: false,
  accounts: [],
};

ResendNewsletterForm.propTypes = {
  isSaving: PropTypes.bool,
  isCompleted: PropTypes.bool,
  form: PropTypes.object.isRequired,
  accounts: PropTypes.array,
  // functions
  fetchSimpleResource: PropTypes.func.isRequired,
  saveResource: PropTypes.func.isRequired,
};

const mapStateToProps = ({ resources }, ownProps) => ({
  accounts: resources.accounts.data,
  isSaving: resources[ownProps.resource].isSaving,
  isCompleted: resources[ownProps.resource].isCompleted,
});

const enhanced = compose(
  Form.create(),
  connect(mapStateToProps, { saveResource, fetchSimpleResource }),
);

export default enhanced(ResendNewsletterForm);



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/ResendNewsletter/ResendNewsletterForm.js